"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const classnames_1 = __importDefault(require("classnames"));
const react_dock_1 = __importDefault(require("react-dock"));
const Header_1 = __importDefault(require("./Header"));
const Draggable_1 = __importDefault(require("./Draggable"));
const SelectInitialForm_1 = __importDefault(require("./SelectInitialForm"));
const RenderFormData_1 = __importDefault(require("./RenderFormData"));
const __utils_1 = __importDefault(require("../styles/_.utils"));
const Dock_1 = __importDefault(require("../styles/Dock"));
exports.default = (0, mobx_react_1.observer)(({ store, handlers }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)(Dock_1.default.dock) },
    react_1.default.createElement(react_dock_1.default, { defaultSize: store.open ? store.dock.size : 0, size: store.open ? store.dock.size : 0, onSizeChange: handlers.handleOnSizeChange, position: store.dock.position, fluid: store.dock.fluid, isVisible: store.dock.visible, dimMode: store.dock.mode, dockStyle: store.dock.style },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Dock_1.default.draggable, store.open && __utils_1.default.hidden) },
            react_1.default.createElement(Draggable_1.default, { handlers: handlers })),
        react_1.default.createElement(Header_1.default, { store: store, handlers: handlers }),
        (store.selected.form && store.selected.key)
            ? react_1.default.createElement(RenderFormData_1.default, { store: store, handlers: handlers })
            : react_1.default.createElement(SelectInitialForm_1.default, { store: store, handlers: handlers })))));
